module.exports = __webpack_public_path__ + "img/mentions.bb03e8d4.png";